import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/motion/Reveal";

function fmtDate(d) {
  try {
    return new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
}

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    api
      .get("/blog")
      .then((r) => { if (!cancel) setPosts(r.data); })
      .catch(() => { if (!cancel) setPosts([]); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, []);

  return (
    <div data-testid="blog-list-page" className="bg-navy">
      <PageHero
        testid="blog-hero"
        overline="Insights & Notes"
        lines={[
          <>Field notes from</>,
          <>
            <em className="italic text-[#C6A87C]">18 years</em> in IP.
          </>,
        ]}
        sub="Short, practical essays on patents, trademarks and IP strategy — written by Venkataramanan and drawn from real cases."
      />
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 xl:px-24 py-20 lg:py-28">
        {loading ? (
          <div data-testid="blog-list-loading" className="text-[#8A99AA] font-light">
            Loading posts…
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={Math.min(i * 0.08, 0.4)} testid={undefined}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group block h-full bg-navy-deep border border-[#C6A87C]/15 overflow-hidden transition-colors duration-500 hover:border-[#C6A87C]/50"
                >
                  <div className="aspect-[16/10] overflow-hidden clip-frame-sm">
                    <img
                      src={p.cover}
                      alt=""
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-3 text-[11px] text-[#8A99AA] uppercase tracking-[0.18em]">
                      <span>{fmtDate(p.published_at)}</span>
                      <span className="w-1 h-1 bg-[#C6A87C] rounded-full" />
                      <span>{p.read_time}</span>
                    </div>
                    <h3 className="mt-4 font-serif text-2xl text-[#F5F4F0] leading-tight group-hover:text-[#C6A87C] transition-colors duration-300">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-[#8A99AA] text-sm leading-relaxed font-light">
                      {p.excerpt}
                    </p>
                    <div className="mt-5 inline-flex items-center gap-2 text-[#C6A87C] text-xs uppercase tracking-[0.14em]">
                      Read essay
                      <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
